import { ReactNode } from 'react';

import { Typography } from '@mui/material';

interface Props {
  className?: string;
  children: ReactNode;
}

const Body = ({ className, children }: Props) => {
  return (
    <Typography className={className} component="div" variant="paragraphRegular">
      {children}
    </Typography>
  );
};

export default Body;
